import { render, staticRenderFns } from "./unit_comp_pc.vue?vue&type=template&id=8cb782ae"
import script from "./unit_comp_pc.vue?vue&type=script&lang=js"
export * from "./unit_comp_pc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports